import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { SessionService } from './../../services/session.service';

@Component({
    selector: 'app-uploadfile',
    templateUrl: './uploadfile.component.html'
})
export class UploadFileComponent implements OnInit {
    errors = [];
    dragAreaClass = 'dragarea';
    files: any[] = [];
    @Input() projectId = 0;
    @Input() sectionId = 0;
    @Input() fileExt = 'JPG, GIF, PNG, PDF';
    @Input() maxFiles = 5;
    @Input() maxSize = 5; // 5MB
    @Input() imgCmp = 'fa fa-file-image-o fa-2x';
    @Input() tipoTexto = 'imagen';
    @ViewChild('file') selectFile: ElementRef;
    adjunto = false;

    constructor(public sessionService: SessionService) { }

    ngOnInit() { }

    onFileChange(event) {
        this.files = this.files.concat(Array.from(event.target.files || []));
        if (this.tipoTexto === 'adjuntos') {
            this.adjunto = true;
        } else {
            this.adjunto = false;
        }
        this.saveFiles();
    }

    saveFiles() {
        this.errors = []; // Clear error
        // Validate file size and allowed extensions
        this.isValidFiles();
        if (this.files.length > 0 && this.errors.length === 0) {
            if (this.adjunto) {
                this.sessionService.attachments = this.files;
            } else {
                this.sessionService.files = this.files;
            }
        } else {
            const dt = new DataTransfer();
            this.files = [];
            this.selectFile.nativeElement.files = dt.files;
            if (this.adjunto) {
                this.sessionService.attachments = [];
            } else {
                this.sessionService.files = [];
            }
        }
    }

    private isValidFiles() {
        // Check Number of files
        if (this.files.length > this.maxFiles) {
            this.errors.push('Solo puede subir ' + this.maxFiles + ' fichero(s)');
        }
        if (this.errors.length === 0) {
            this.isValidFileExtension();
        }
    }

    private isValidFileExtension() {
        // Make array of file extensions
        const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleUpperCase().trim(); });
        for (let i = 0; i < this.files.length; i++) {
            // Get file extension
            const ext = this.files[i].name.toUpperCase().split('.').pop() || this.files[i].name;
            // Check the extension exists
            const exists = extensions.includes(ext);
            if (!exists) {
                if (extensions.includes('PDF') && extensions.includes('JPG')) {
                    this.errors.push('Debe seleccionar un archivo de imagen o PDF');
                } else if (extensions.includes('JPG')) {
                    this.errors.push('Debe seleccionar un archivo de imagen');
                } else if (extensions.includes('PDF')) {
                    this.errors.push('Debe seleccionar un archivo PDF');
                }
            }
            // Check file size
            this.isValidFileSize(this.files[i]);
        }
    }

    private isValidFileSize(file) {
        const fileSizeinMB = file.size / (1024 * 1000);
        const size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
        if (size > this.maxSize) {
            this.errors.push('Error (File Size): ' + file.name + ': exceed file size limit of ' + this.maxSize + 'MB ( ' + size + 'MB )');
        }
    }

    public reset(file?) {
        // console.log(this.selectFile.nativeElement.files);
        const dt = new DataTransfer();
        if (file === undefined) {
            this.selectFile.nativeElement.files = dt.files;
            this.files = [];
        } else if (this.files.length > 0) {
            if (this.files.length === 1) {
                this.selectFile.nativeElement.files = dt.files;
                this.files = [];
                if (this.adjunto) {
                    this.sessionService.attachments = [];
                } else {
                    this.sessionService.files = [];
                }
            } else {
                if (this.files.includes(file)) {
                    this.files = this.files.filter(f => f !== file);
                    this.files.forEach(f => { dt.items.add(f); });
                    this.selectFile.nativeElement.files = dt.files;
                    if (this.adjunto) {
                        this.sessionService.attachments = this.files;
                    } else {
                        this.sessionService.files = this.files;
                    }
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/Components/uploadfile.component.ts